module.exports = __webpack_public_path__ + "img/style_model_preview_675.b70e1d61.jpg";